import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";

import { Card } from "react-bootstrap";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

const SelectStatus = (props) => {
  const translateForm = "global";
  const { t } = useTranslation();
  const {
    data,
    handleInputChange,
    active,
    free,
    trending,
    shoppable,
    discount,
    row,
    prominently,
  } = props;

  return (
    <Fragment>
      <FormControl fullWidth>
        <FormGroup row={row}>
          {active && (
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="active"
                  checked={!!data?.active}
                  onChange={handleInputChange}
                />
              }
              label={t(`${translateForm}.active`)}
            />
          )}
          {shoppable && (
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="shoppable"
                  checked={!!data?.shoppable}
                  onChange={handleInputChange}
                  disabled={!!data?.free}
                />
              }
              label={t(`${translateForm}.shoppable`)}
            />
          )}
          {free && (
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="free"
                  checked={!!data?.free}
                  onChange={handleInputChange}
                  disabled={!!data?.shoppable}
                />
              }
              label={t(`${translateForm}.free`)}
            />
          )}
          {prominently && (
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="prominently"
                  checked={!!data?.prominently}
                  onChange={handleInputChange}
                />
              }
              label={t(`${translateForm}.prominently`)}
            />
          )}
          {/* {trending && (
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="trending"
                  checked={!!data?.trending}
                  onChange={handleInputChange}
                />
              }
              label={t(`${translateForm}.trending`)}
            />
          )} */}
          {discount && (
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  name="discount"
                  checked={!!data?.discount}
                  onChange={handleInputChange}
                  disabled={!data?.shoppable}
                />
              }
              label={t(`${translateForm}.discount`)}
            />
          )}
        </FormGroup>
      </FormControl>
    </Fragment>
  );
};

export default SelectStatus;
